import { render, staticRenderFns } from "./MyIncidents.vue?vue&type=template&id=1c71c3dd&"
import script from "./MyIncidents.vue?vue&type=script&lang=js&"
export * from "./MyIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports